import { ISensorDigitalAlarm } from './types'
import { Badge } from 'baseui/badge';
import { FormattedMessage } from 'react-intl';

export function SmallPanelFreeze(props: ISensorDigitalAlarm) {

    return <>
        {props.isErr &&
            <Badge hierarchy='primary' color='negative' content={<FormattedMessage id="SensorDigitalAlarm.Antifreeze" defaultMessage="Antifreeze"></FormattedMessage>} />
        }
    </>
}